import React from "react";
import ProjectsHero from "../components/projects/ProjectsHero";
import ProjectsGrid from "../components/projects/ProjectsGrid";
const Project = () => {
  return (
    <>
      <ProjectsHero />
      <ProjectsGrid/>
    </>
  );
};

export default Project;
